import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { v4 as uuidv4 } from 'uuid';
import { chatApi } from './chatApi';

export const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    messages: [
      {
        id: uuidv4(),
        sender: 'H',
        text: 'May i help you?',
        timestamp: new Date().toISOString()
      }
    ]
  },
  reducers: {
    addMessage: (state, action) => {
      state.messages.push({
        id: uuidv4(),
        sender: 'ME',
        text: action.payload.text,
        timestamp: new Date().toISOString()
      });
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      chatApi.endpoints.insertChats.matchFulfilled,
      (state, { payload }) => {
        state.messages.push({
          id: uuidv4(),
          sender: 'H',
          text: payload.message,
          timestamp: new Date().toISOString()
        });
      }
    );
    builder.addMatcher(
      chatApi.endpoints.insertChatsUser.matchFulfilled,
      (state, { payload }) => {
        state.messages.push({
          id: uuidv4(),
          sender: 'H',
          text: payload.message,
          timestamp: new Date().toISOString()
        });
      }
    );
  }
});

export const { addMessage } = chatSlice.actions;
export const selectLogic = (state: RootState) => state.chat;
export default chatSlice.reducer;

